import React from "react";
import SbEditable from "storyblok-react";
import Components from "../components";
import Section from "@/components/Section/section";
import LayoutGrid from "../Layout/layout-grid";
import CoachCard from "@/components/Coaches/coach-card";
import classnames from "classnames";
import Main from "@/components/Layout/main";
import SectionItem from "@/components/Section/section-item";
import styles from "./coach.module.scss";
import FormNewsletter from "@/components/FormNewsletter/form-newsletter";
import { CoachesPageStoryblok } from "@/types/component-types-sb";
import { GetCoachCards } from "@/lib/storyblok-gapi";

interface Props {
  content: CoachesPageStoryblok;
  blok: CoachesPageStoryblok;
  coaches: GetCoachCards;
  headCoaches?: GetCoachCards;
}

const CoachesIndex = (props: Props) => {
  const {
    content: { body },
    coaches,
    headCoaches,
  } = props;
  const bodyBloks = Array.isArray(body) ? body : [];
  const coachCards = Array.isArray(coaches) ? coaches : [];
  const headCoachCards = Array.isArray(headCoaches) ? headCoaches : [];
  const hasHeadCoaches = headCoachCards.length > 0;
  const hasTwoHeadCoaches = headCoachCards.length === 2;
  const layoutVars = {
    ["--cols-m" as string]: 1,
    ["--cols-d" as string]: 3,
    ["--col-start" as string]: "main-start",
    ["--col-end" as string]: "main-end",
  };
  const gridClasses = classnames(styles.coachesGrid);
  const headCoachesGridClasses = classnames(
    styles.coachesGrid,
    hasTwoHeadCoaches ? styles.coachesGridTwoUp : ""
  );

  return (
    // @ts-expect-error
    <SbEditable content={props.content}>
      <Main className="page-main">
        <Section {...props.blok} component="section">
          {bodyBloks.length
            ? bodyBloks.map((blok) => {
                return (
                  <SectionItem
                    key={blok._uid}
                    {...blok}
                    className={blok.component}
                  >
                    {React.createElement(Components(blok.component), {
                      blok,
                    })}
                  </SectionItem>
                );
              })
            : null}
          {hasHeadCoaches ? (
            <>
              <h2
                className={classnames("ef-h3 u-mb-0", styles.coachesSubheader)}
              >
                Head Coaches
              </h2>
              <LayoutGrid vars={layoutVars} className={headCoachesGridClasses}>
                {headCoachCards.length
                  ? headCoachCards.map((blok) => (
                      <CoachCard key={blok.uuid} {...blok} />
                    ))
                  : null}
              </LayoutGrid>
              <h2
                className={classnames("ef-h3 u-mb-0", styles.coachesSubheader)}
              >
                Coaches
              </h2>
            </>
          ) : null}
          <LayoutGrid vars={layoutVars} className={gridClasses}>
            {coachCards.length
              ? coachCards.map((blok) => (
                  <CoachCard key={blok.uuid} {...blok} />
                ))
              : null}
          </LayoutGrid>
          <FormNewsletter />
        </Section>
      </Main>
    </SbEditable>
  );
};

export default CoachesIndex;
